import { useState, useEffect, useRef } from 'react';
import { Row, Col, Button, Table, Input, Card, CardBody, Label, FormGroup, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import Select from 'react-select';
import { Formik, Field, Form, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { useParams, useNavigate, Link } from 'react-router-dom';
import axiosInstance from 'pages/Utility/axiosInstance';
import { ClipLoader, FadeLoader } from 'react-spinners';
import { getCatalogItems, getAddresses, fetchAddressesRequest, getShifts, getSebelUsers, getTeams } from 'store/actions';
import { useDispatch, useSelector } from 'react-redux';
import Breadcrumb from 'components/Common/Breadcrumb2';
import { showError, showSuccess } from 'helpers/notification_helper';
import { quantity } from 'chartist';
import { FaCloudUploadAlt } from 'react-icons/fa';
import { convertDateFormat, fetchDateFromDateTime, formatDate, formatTime } from 'helpers/dateFormat_helper';
import SiteSurveyDetails from './SiteSurveyDetails';
import Cookies from 'js-cookie';
import { addMinutesToTime } from 'helpers/common_helper';


const EditSiteSurvey = () => {
    const [selectedCatalogItem, setSelectedCatalogItem] = useState(null);
    const [catalogueItems, setCatalogueItems] = useState();
    const [itemQuantity, setItemQuantity] = useState('');
    const [SiteSurveyDetails, setSiteSurveyDetails] = useState();
    const [addresses, setAddresses] = useState([]);
    const [selectedAddress, setSelectedAddress] = useState();
    const [SiteSurveyItems, setSiteSurveyItems] = useState([]);
    const [loading, setLoading] = useState(false);
    const catalogItems = useSelector((state) => state.Catalog.catalogItems);
    const teams = useSelector((state) => state.Team.teams);
    const availableAddresses = useSelector((state) => state.Address.addresses);
    const sebelUsers = useSelector((state) => state.SebelUser.users);
    const shifts = useSelector((state) => state?.Shift?.shifts);
    const [uniqueTeams, setUniqueTeams] = useState();
    const [availableSlots, setAvailableSlots] = useState(null);
    const [selectedSlot, setSelectedSlot] = useState(null);
    const [modal, setModal] = useState(false);
    const [selectedTime, setSelectedTime] = useState();
    const [highlightedSlot, setHighlightedSlot] = useState(null);
    const [selectedShift, setSelectedShift] = useState(null);
    const [sebelUserId,setSebelUserId] = useState();
    const [scheduledStartDateTime, setScheduledStartDateTime] = useState();
    const authUser = JSON.parse(Cookies.get('authUser'));
    const [loader, setLoader] = useState(false);
    const { id } = useParams();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [fileError, setFileError] = useState('');
    const [team,setTeam]= useState();
    const [tempTime,setTempTime] = useState();
    const permissions2 = JSON.parse(localStorage?.getItem('permissions'));

    if (!permissions2?.map(item => item?.permissionName)?.includes("Edit SiteSurvey")) {
        navigate('/pages-403')
    }

    const fetchSiteSurveyDetails = async () => {
        setLoader(true);
        try {
            const response = await axiosInstance.get('', { params: { sp: 'usp_GetSiteSurveyProfile', SiteSurveyId: id } });
            setSiteSurveyDetails(response?.data?.Data?.[0]);
            setLoader(false);
        } catch (error) {
            setLoader(false);
        }
    };

    useEffect(() => {
        if (SiteSurveyDetails?.CustomerProfile) {
            dispatch(fetchAddressesRequest(JSON?.parse(SiteSurveyDetails?.CustomerProfile)?.[0]?.customerId));
        }
        if (SiteSurveyDetails?.SiteSurveyItems) {
            setSiteSurveyItems(JSON.parse(SiteSurveyDetails?.SiteSurveyItems)?.map(item => {
                return ({
                    catalogueId: item?.catalogueId,
                    catalogueItem: item?.catalogueItem,
                    surveyTime: item?.surveyTimes,
                    quantity: item?.quantity,
                    image: item?.image
                })
            }
            ))
        }
    }, [SiteSurveyDetails?.CustomerProfile]);


    // useEffect(() => {
    //     if (catalogItems?.Data?.length > 0) {
    //         const groupedByCategory = catalogItems?.Data?.reduce((acc, item) => {
    //             const { categoryName, itemName, catalogueId, surveyTime, image } = item;

    //             // Check if the category already exists in the accumulator
    //             if (!acc[categoryName]) {
    //                 acc[categoryName] = [];
    //             }

    //             // Push the item into the respective category
    //             acc[categoryName].push({
    //                 value: catalogueId,
    //                 label: itemName,  // label as the catalogueId (string)
    //                 surveyTime: surveyTime,
    //                 image: image
    //             });

    //             return acc;
    //         }, {});

    //         // Step 2: Create the desired options array
    //         const optionsArray = Object.keys(groupedByCategory).map((categoryName) => {
    //             return {
    //                 label: categoryName,  // Use category name as label
    //                 options: groupedByCategory[categoryName],  // Use the grouped items as options
    //             };
    //         });
    //         setCatalogueItems(optionsArray);
    //     }
    // }, [catalogItems, SiteSurveyDetails?.CustomerProfile?.[0]]);

    useEffect(() => {
        fetchSiteSurveyDetails();
        dispatch(getShifts())
        dispatch(getSebelUsers())
    }, []);

    useEffect(()=>{
        dispatch(getTeams(id));
    },[id])

    const filterTeams = () => {
        return availableSlots?.filter((team) => {
            const fromTime = new Date(team.FromTime).getTime();
            const toTime = new Date(team.ToTime).getTime();
            const startTime = new Date(SiteSurveyDetails?.scheduledStartDateTime).getTime();
            const endTime = new Date(SiteSurveyDetails?.scheduledEndDateTime).getTime();

            // Check if the scheduled times are between FromTime and ToTime
            return startTime >= fromTime && endTime <= toTime;
        });
    };

    useEffect(() => {
        setSebelUserId(SiteSurveyDetails?.sabelUserId)
        if (SiteSurveyDetails?.customerAddresses) {
            setSelectedAddress({ ...JSON.parse(SiteSurveyDetails?.customerAddresses)?.[0], customerAddressId: SiteSurveyDetails?.customerAddressId });

        }
        setScheduledStartDateTime(fetchDateFromDateTime(SiteSurveyDetails?.scheduledStartDateTime))
        setSelectedShift({ label: teams?.Data?.filter(item => item?.teamId == SiteSurveyDetails?.teamId)?.[0]?.shiftName, value: teams?.Data?.filter(item => item?.teamId == SiteSurveyDetails?.teamId)?.[0]?.shiftId })
        setSelectedSlot({ team: filterTeams(), slot: filterTeams() });
        setSelectedTime(new Date(SiteSurveyDetails?.scheduledStartDateTime).toLocaleTimeString([], {
            hour: "2-digit",
            minute: "2-digit",
            hourCycle: "h23",
        }))
        setHighlightedSlot({
            teamId: SiteSurveyDetails?.teamId,
            fromTime: SiteSurveyDetails?.scheduledStartDateTime,
            toTime: SiteSurveyDetails?.scheduledEndDateTime,
            selectedTime: new Date(SiteSurveyDetails?.scheduledStartDateTime).toLocaleTimeString([], {
                hour: "2-digit",
                minute: "2-digit",
                hourCycle: "h23",
            }),
        })
    }, [SiteSurveyDetails]);

    const handleDeleteSiteSurveyItem = (id) => {
        setSiteSurveyItems(SiteSurveyItems.filter((_, index) => index !== id));
    };

    const validationSchema = Yup.object({
        SiteSurveyNumber: Yup.string(),
        teamId: Yup.string(),
        scheduledStartDateTime: Yup.string()
            .required('Scheduled Start Date is required')
            .test('is-not-past', 'Scheduled Start Date cannot be in the past', function (value) {
                if (!value) return true;
                const currentDateTime = new Date();
                currentDateTime.setHours(0, 0, 0, 0); // Remove time

                const selectedDateTime = new Date(value);
                selectedDateTime.setHours(0, 0, 0, 0);
                return selectedDateTime >= currentDateTime;
            }),
        agentComments: Yup.string().required('Agent Comments are required'),
    });

    const handleAddSiteSurveyItem = () => {
        if (SiteSurveyItems?.filter(item => item?.catalogueId == selectedCatalogItem?.value)?.length === 1) {
            showError("Site Survey item already exists")
        } else if (!selectedCatalogItem) {
            showError("Please select a Site Survey item !")
        } else if (!itemQuantity) {
            showError("Please enter the quantity")
        } else if (selectedCatalogItem && itemQuantity) {
            const newItem = {
                catalogueId: selectedCatalogItem?.value,
                catalogueItem: selectedCatalogItem?.label,
                surveyTime: selectedCatalogItem?.surveyTime,
                quantity: itemQuantity,
                image: selectedCatalogItem?.image
            };
            setSiteSurveyItems([...SiteSurveyItems, newItem]);
            setSelectedCatalogItem(null);
            setItemQuantity('');
        }
    };

    const handleAddressSelect = (address) => {
        setSelectedAddress(address.customerAddressId === selectedAddress?.customerAddressId ? null : address);
    };

    const fetchAvailableSlots = async () => {
        try {
            const response = await axiosInstance.get('', { params: { sp: "usp_GetShiftTeamAvailability", shiftId: selectedShift?.value ? selectedShift?.value : null, scheduledDate: scheduledStartDateTime ? scheduledStartDateTime : null, solutionId: SiteSurveyDetails?.solutionId,customerId: selectedCustomer?.value } });
            if (response) {
                setAvailableSlots(response?.data?.Data);
            }
        } catch (error) {

        }
    }

    useEffect(() => {
        if (scheduledStartDateTime && selectedShift?.value && id) {
            fetchAvailableSlots();
        }
    }, [scheduledStartDateTime, selectedShift, id])

    const toggleModal = () => setModal(!modal);

    const handleSlotClick = (team, slot) => {
        setTeam(team);
        setTempTime("")
        setSelectedSlot({ team, slot });
        toggleModal();
    };

       const handleTimeChange = (e) => {
           setTempTime(e.target.value)
       };

    const handleContinue = () => {
        if (!selectedSlot) return;

        if (
            (!tempTime && !selectedTime) ||
            (!tempTime && selectedTime && (
                selectedSlot?.slot.FromTime !== highlightedSlot?.fromTime ||
                selectedSlot?.slot.ToTime !== highlightedSlot?.toTime ||
                selectedSlot?.team.teamId !== highlightedSlot?.teamId
              ))
          ) {
            showError("Please select the time");
            return;
        }
        // Construct date from selectedSlot's date and tempTime
        const selectedDate = new Date(selectedSlot.slot.FromTime);
        const [selectedHour, selectedMinute] = tempTime.split(":");
        selectedDate.setHours(parseInt(selectedHour, 10));
        selectedDate.setMinutes(parseInt(selectedMinute, 10));
        selectedDate.setSeconds(0);
        selectedDate.setMilliseconds(0);
    
        const selectedStartDateTime = new Date(selectedDate);
        const currentDateTime = new Date();

        const isSameDay = selectedStartDateTime.toDateString() === currentDateTime.toDateString();
        if (isSameDay && selectedStartDateTime <= currentDateTime) {
            showError("Please select a future time");
            return;
        }
        
        const totalEstimatedTimeInMs = (
            SiteSurveyItems?.length
                ? SiteSurveyItems.reduce((sum, item) => sum + (item?.estimatedTime || 0), 0)
                : 60 // default 60 minutes
        ) * 60000; 

        const calculatedEndDateTime = new Date(
            selectedStartDateTime.getTime() + totalEstimatedTimeInMs
        );

        const slotEndTime = new Date(selectedSlot.slot.ToTime);

        // Validation: Check if calculated end time exceeds slot's end time
        if (calculatedEndDateTime > slotEndTime) {
            showError("The selected time and estimated work exceed the slot's end time!");
            return;
        }
        const fromTime = new Date(selectedSlot.slot.FromTime).getTime();
        const toTime = new Date(selectedSlot.slot.ToTime).getTime();

        const selectedTimeInMs = selectedDate.getTime();

        // Validation
        if (selectedTimeInMs < fromTime || selectedTimeInMs > toTime) {
            showError("Selected time is not within the range of this slot!")
            return;
        }

        if (tempTime){
            setSelectedTime(tempTime);
        }

        // Highlight the selected slot
        setHighlightedSlot({
            teamId: selectedSlot.team.teamId,
            fromTime: selectedSlot.slot.FromTime,
            toTime: selectedSlot.slot.ToTime,
            selectedTime:tempTime,
        });

        toggleModal();

    };

    useEffect(() => {
        if (availableSlots) {
            setUniqueTeams(availableSlots?.reduce((acc, team) => {
                if (!acc.some(t => t.teamId === team.teamId)) {
                    acc.push(team);
                }
                return acc;
            }, []))
        }
    }, [availableSlots])

    const checkDate = ()=>{
        if (scheduledStartDateTime) {
             const selectedStartDateTime = new Date(formatDate(`${scheduledStartDateTime}T${selectedTime}:00`));
                const currentDateTime = new Date();
                // Validate: Must be in future if same day
                const isSameDay = selectedStartDateTime === currentDateTime;
                if (isSameDay) {
                    showError("Please select a future start date")
                }
            }
    }

    function formatToHHMM(date) {
        return date.toTimeString().slice(0, 5); // Returns "14:30"
      }
      

    const customOption = (props) => {
        const { data, innerRef, innerProps } = props;

        return (
            <div ref={innerRef} {...innerProps} style={{ display: 'flex', alignItems: 'center' }} className='p-2'>
                <img src={`${process.env.REACT_APP_BASE_URL}${data.image}`} alt={data.label} style={{ width: 20, height: 20, marginRight: 10, borderRadius: "10px" }} />
                <span>{data.label}</span>
            </div>
        );
    };


    return (
        <div className="page-content">
            <div className="d-flex justify-content-between align-items-center mx-2">
                <Breadcrumb title="Edit Site Survey" breadcrumbItems={[{ title: 'Dashboard', link: '/dashboard' }, { title: 'Edit Site Survey', link: '#' }]} />
                <Button className="bg-primary text-white d-flex justify-content-center gap-1 align-items-center" onClick={() => navigate(`/SiteSurveyDetails/${id}`)}>
                    Back
                </Button>
            </div>
            {(!loader && SiteSurveyDetails) && (
                <Formik
                    initialValues={{
                        SiteSurveyId: id || '',
                        teamId: SiteSurveyDetails?.teamId || '',
                        scheduledStartDateTime: SiteSurveyDetails?.scheduledStartDateTime || '',
                        scheduledEndDateTime: SiteSurveyDetails?.scheduledEndDateTime || '',
                        agentComments: SiteSurveyDetails?.agentComments || '',
                    }}
                    validationSchema={validationSchema}
                    onSubmit={async (values) => {
                        if (!selectedAddress) {
                            showError("Please select the address")
                        } else if (!selectedSlot) {
                            showError("Please select the slot")
                        } else {
                            try {
                                setLoading(true)
                                const response = await axiosInstance.post(``, {
                                    "sp": "usp_UpdateSiteSurvey",
                                    "SiteSurveyId": id,
                                    "teamId": highlightedSlot?.teamId ? highlightedSlot?.teamId : SiteSurveyDetails?.teamId,
                                    "scheduledStartDateTime": formatDate(`${scheduledStartDateTime}T${selectedTime}:00`),
                                    "scheduledEndDateTime": formatDate(new Date(`${scheduledStartDateTime}T${selectedTime}:00`).getTime() + (60 * 60000)),
                                    "agentComments": values?.agentComments,
                                    "customerAddressId": selectedAddress?.customerAddressId,
                                    "SiteSurveyItemsJson": SiteSurveyItems ? JSON?.stringify({ items: SiteSurveyItems?.map(item => ({ catalogueId: item?.catalogueId, quantity: item?.quantity })) }) : "",
                                    "solutionId":SiteSurveyDetails?.solutionId,
                                    "sabelUserId":sebelUserId
                                }
                                )
                                if (response) {
                                    showSuccess('SiteSurvey updated successfully')
                                    setLoading(false)
                                    navigate(`/SiteSurveyDetails/${id}`)
                                }
                            } catch (error) {
                                console.log(error);
                                setLoading(false)
                            }
                        }
                    }}
                >
                    {({ setFieldValue, values, errors, touched }) => (
                        <Form className='bg-white p-3 rounded-2'>
                            <div className='' >
                                <label for="sebelUserId" className=''>Siebel User ID</label>
                                <Select
                                    id="sebelUserId"
                                    options={sebelUsers?.Data?.map(item=>({label:item?.sabelUserId,value:item?.id}))}
                                    value={sebelUsers?.Data?.map(item=>({label:item?.sabelUserId,value:item?.id}))?.find(option=>option?.value == sebelUserId || "")}
                                    onChange={option=>{setSebelUserId(option?.value ||"")}}
                                    placeholder="Select Siebel User ID"
                                    isClearable={true}
                                    styles={{
                                        container: (base) => ({
                                        ...base,
                                        maxWidth: '200px',
                                        }),
                                    }}
                                />
                                    {errors.sebelUserId && <div className="text-danger">{errors.sebelUserId}</div>}
                            </div>
                            <Row className="mt-3">
                                <Col md={6}>
                                    <label htmlFor="SiteSurveyId">Site Survey Number</label> <span className='text-danger'>*</span>
                                    <Field
                                        name="SiteSurveyNumber"
                                        type="text"
                                        value={SiteSurveyDetails?.siteSurveyNumber}
                                        className="form-control"
                                        disabled
                                        placeholder="Site Survey ID"
                                    />
                                    <ErrorMessage name="SiteSurveyId" component="div" className="text-danger" />
                                </Col>
                            </Row>

                            <Row className="mt-3">
                                <Col md={6}>
                                    <label htmlFor="scheduledStartDateTime">Scheduled Start Date</label> <span className='text-danger'>*</span>
                                    <Input
                                        type="date"
                                        value={scheduledStartDateTime}
                                        onChange={(e) => { setScheduledStartDateTime(e.target.value); setFieldValue('scheduledStartDateTime', e.target.value); setSelectedSlot(""); setSelectedTime(undefined); setHighlightedSlot(null);}}
                                        min={new Date().toISOString().split('T')[0]}
                                        placeholder="Scheduled Start Date"
                                        style={{ border: "1px solid lightgray", height: "38px" }}
                                    />
                                    <ErrorMessage name="scheduledStartDateTime" component="div" className="text-danger" />
                                </Col>
                                <Col md={6}>
                                    <FormGroup>
                                        <Label>Select Shift</Label> <span className='text-danger'>*</span>
                                        <Select
                                            options={shifts?.Data?.map(item => ({ label: item?.shiftName, value: item?.shiftId }))}
                                            value={selectedShift}
                                            onChange={setSelectedShift}
                                            placeholder="Select a Shift"
                                            isClearable={true}
                                        />
                                        {errors.selectedShift && <div className="text-danger">{errors.selectedShift}</div>}
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row className="pb-3">
                                <h5>Available Slots <span className='' style={{ fontSize: "14px" }}> 
                                    (Current Slot: {selectedTime || formatToHHMM(new Date(SiteSurveyDetails?.scheduledStartDateTime))} - 
                                    {addMinutesToTime(
                                        selectedTime 
                                        ? selectedTime 
                                        : formatToHHMM(new Date(SiteSurveyDetails?.scheduledStartDateTime)),
                                        60
                                    )
                                    })
                                </span></h5>
                                <Col md={12} style={{ overflowX: "auto" }}>
                                    <Table hover>
                                        <thead>
                                            {/* <tr>
                                            <th>Team</th>
                                            <th>Available Slots</th>
                                        </tr> */}
                                        </thead>
                                        <tbody>
                                            {uniqueTeams?.map((team, index) => (
                                                <tr key={team.teamId}>
                                                    <td className="" style={{ whiteSpace: "nowrap", verticalAlign: "middle" }}>{authUser?.userRole === "Super Admin" ? team?.teamName : authUser?.userRole === "Supervisor" ? team?.teamName : `Slot-${index + 1}`}</td>
                                                    <td>
                                                        <div className="d-flex justify-content-start align-items-center gap-3">
                                                        {availableSlots?.filter((slot) => slot.teamId === team.teamId)
                                                                .reduce((uniqueSlots, slot) => {
                                                                    if (
                                                                        !uniqueSlots.some(
                                                                            (s) => s.FromTime === slot.FromTime && s.ToTime === slot.ToTime
                                                                        )
                                                                    ) {
                                                                        uniqueSlots.push(slot);
                                                                    }
                                                                    return uniqueSlots;
                                                                }, [])
                                                                .map((slot, index) => (
                                                                    <div
                                                                        key={index}
                                                                        onClick={() =>
                                                                            slot.TimeType !== "Engaged" ? handleSlotClick(team, slot) : ""
                                                                        }
                                                                        style={{
                                                                            backgroundColor:
                                                                                slot.TimeType === "Engaged" ? "lightgray" : "rgb(144, 238, 144)",
                                                                            padding: "7px",
                                                                            margin: "5px 0",
                                                                            cursor: slot.TimeType === "Engaged" ? "not-allowed" : "pointer",
                                                                            opacity: slot.TimeType === "Engaged" ? 0.5 : 1,
                                                                            border: highlightedSlot?.teamId == team.teamId &&
                                                                                (highlightedSlot?.selectedTime >= new Date(slot.FromTime).toLocaleTimeString([], {
                                                                                    hour: "2-digit",
                                                                                    minute: "2-digit",
                                                                                    hour12: false
                                                                                }) &&
                                                                                    highlightedSlot?.selectedTime < new Date(slot.ToTime).toLocaleTimeString([], {
                                                                                        hour: "2-digit",
                                                                                        minute: "2-digit",
                                                                                        hour12: false
                                                                                    }))
                                                                                ? "2px solid blue"
                                                                                : "1px solid lightgray",
                                                                            borderRadius: "5px",
                                                                            whiteSpace: "nowrap",
                                                                            color: highlightedSlot?.teamId == team.teamId &&
                                                                                highlightedSlot?.selectedTime >= new Date(slot.FromTime).toLocaleTimeString([], {
                                                                                    hour: "2-digit",
                                                                                    minute: "2-digit",
                                                                                    hour12: false
                                                                                }) &&
                                                                                highlightedSlot?.selectedTime < new Date(slot.ToTime).toLocaleTimeString([], {
                                                                                    hour: "2-digit",
                                                                                    minute: "2-digit",
                                                                                    hour12: false
                                                                                })
                                                                                ? "blue"
                                                                                : slot.TimeType === "Engaged" ? "black" : "white",
                                                                            fontSize: "12px"
                                                                        }}
                                                                    >
                                                                        {new Date(slot.FromTime).toLocaleTimeString([], {
                                                                            hour: "2-digit",
                                                                            minute: "2-digit",
                                                                        })}{" "}
                                                                        -{" "}
                                                                        {new Date(slot.ToTime).toLocaleTimeString([], {
                                                                            hour: "2-digit",
                                                                            minute: "2-digit",
                                                                        })}
                                                                    </div>
                                                                ))}
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))}
                                            {uniqueTeams?.length <= 0 && <div className='text-center'>No Slots Available</div>}
                                        </tbody>
                                    </Table>
                                </Col>
                            </Row>

                            {selectedSlot && <Modal isOpen={modal} toggle={toggleModal} centered>
                                <ModalHeader toggle={toggleModal}>Select Time</ModalHeader>
                                <ModalBody>
                                    <div>
                                        Selected Slot : {new Date(selectedSlot?.slot?.FromTime).toLocaleTimeString([], {
                                            hour: "2-digit",
                                            minute: "2-digit",
                                        })}{" "}
                                        -{" "}
                                        {new Date(selectedSlot?.slot?.ToTime).toLocaleTimeString([], {
                                            hour: "2-digit",
                                            minute: "2-digit",
                                        })}
                                    </div>
                                    <div className='d-flex flex-column'>
                                        <label>Select Time:</label>
                                        <input
                                            type="time"
                                            value={(highlightedSlot?.teamId == team?.teamId && 
                                                highlightedSlot?.selectedTime >=  new Date(selectedSlot?.slot?.FromTime).toLocaleTimeString([], {
                                                    hour: "2-digit",
                                                    minute: "2-digit",
                                                    hour12: false
                                                }) &&
                                                highlightedSlot?.selectedTime < new Date(selectedSlot?.slot?.ToTime).toLocaleTimeString([], {
                                                    hour: "2-digit",
                                                    minute: "2-digit",
                                                    hour12: false
                                                })
                                            ) ?  tempTime || selectedTime:tempTime}
                                            onChange={handleTimeChange}
                                            min={formatTime(selectedSlot?.slot?.FromTime)}
                                            max={formatTime(selectedSlot?.slot?.ToTime)}
                                        />
                                    </div>
                                </ModalBody>
                                <ModalFooter>
                                    <Button color="primary" onClick={handleContinue}>
                                        Continue
                                    </Button>
                                    <Button color="secondary" onClick={toggleModal}>
                                        Cancel
                                    </Button>
                                </ModalFooter>
                            </Modal>}

                            <Row className="mt-3">
                                <Col md={12}>
                                    <label htmlFor="agentComments">Agent Comments</label> <span className='text-danger'>*</span>
                                    <Field
                                        name="agentComments"
                                        as="textarea"
                                        className="form-control"
                                        placeholder="Enter agent comments"
                                    />
                                    <ErrorMessage name="agentComments" component="div" className="text-danger" />
                                </Col>
                            </Row>

                            <Row className="mt-3">
                                <Col md={12}>
                                    <h5>Select Address <span className='text-danger'>*</span></h5>
                                    <div className="d-flex flex-wrap">
                                        {availableAddresses?.Data?.map((address) => (
                                            <Card
                                                key={address.customerAddressId}
                                                className={`m-2 ${selectedAddress?.customerAddressId === address.customerAddressId ? 'border-success' : 'border-secondary'}`}
                                                onClick={() => handleAddressSelect(address)}  // Entire Card is clickable
                                                style={{
                                                    cursor: 'pointer',
                                                    width: '200px',
                                                    transition: 'box-shadow 0.3s ease',
                                                    boxShadow: selectedAddress?.customerAddressId === address.customerAddressId
                                                        ? '0 4px 8px rgba(0, 123, 255, 0.5)'
                                                        : '0 2px 4px rgba(0, 0, 0, 0.1)',
                                                }}
                                            >
                                                <CardBody>
                                                    <FormGroup check>
                                                        <Label check style={{ cursor: 'pointer' }}> {/* Ensure label is also clickable */}
                                                            {/* Remove the Input's readOnly */}
                                                            <Input
                                                                type="radio"
                                                                name="address"
                                                                checked={selectedAddress?.customerAddressId === address.customerAddressId}
                                                                onChange={() => { }} // No need for any logic on change

                                                            />
                                                            <h5>Address #{address.customerAddressId}</h5>
                                                            <p className='mb-0'>{address.addressLine}, {address.area}</p>
                                                            <p className='mb-0'>{address.areaDescription}</p>
                                                            <p>{address.landmark}</p>
                                                        </Label>
                                                    </FormGroup>
                                                </CardBody>
                                            </Card>
                                        ))}
                                    </div>
                                </Col>
                            </Row>

                            {/* Site Survey Items Section */}
                            {SiteSurveyDetails?.SiteSurveyStatus === "Sitesurvey Started" && <div className="mt-4">
                                <h5>Add Site Survey Items</h5>
                                <Row className="">
                                    <Col md={6}>
                                        <Select
                                            options={catalogueItems}
                                            value={selectedCatalogItem}
                                            onChange={setSelectedCatalogItem}
                                            placeholder="Select Catalog Item"
                                            isClearable={true}
                                            components={{ Option: customOption }}
                                        />
                                    </Col>
                                    <Col md={3}>
                                        <Input
                                            type="number"
                                            value={itemQuantity}
                                            onChange={(e) => setItemQuantity(e.target.value)}
                                            placeholder="Quantity"
                                            style={{ height: "38px", border: "1px solid lightgray" }}
                                        />
                                    </Col>
                                    <Col md={3} className="d-flex align-items-center">
                                        <Button color="success" onClick={handleAddSiteSurveyItem}>
                                            + Add Item
                                        </Button>
                                    </Col>
                                </Row>
                                <ErrorMessage name="SiteSurveyItems" component="div" className="text-danger" />
                            </div>}

                            {/* Site Survey Items Table */}
                            {(SiteSurveyItems?.length > 0 && SiteSurveyDetails?.SiteSurveyStatus === "Sitesurvey Started") && (
                                <Table responsive striped className='mt-3' style={{ border: "1px solid lightgray" }}>
                                    <thead>
                                        <tr>
                                            <th style={{ border: "1px solid lightgray" }}>Image</th>
                                            <th style={{ border: "1px solid lightgray" }}>Item</th>
                                            <th style={{ border: "1px solid lightgray" }}>Quantity</th>
                                            <th style={{ border: "1px solid lightgray" }}>Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {SiteSurveyItems?.map((item, index) => (
                                            <tr key={index}>
                                                <td className='border-1'>{<img src={`${process.env.REACT_APP_BASE_URL}${item?.image}`} style={{ objectFit: "cover", width: "50px", height: "50px", borderRadius: "25px" }} />}</td>
                                                <td className="text-center" style={{ border: "1px solid lightgray", verticalAlign: "middle" }}>
                                                    {item.catalogueItem}
                                                </td>
                                                <td className="text-center" style={{ border: "1px solid lightgray", verticalAlign: "middle" }}>
                                                    {item.quantity}
                                                </td>
                                                <td className="text-center" style={{ border: "1px solid lightgray", verticalAlign: "middle" }}>
                                                    <Button color="danger" onClick={() => handleDeleteSiteSurveyItem(index)}>
                                                        Delete
                                                    </Button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                            )}

                            <h6 className='pt-1'>Total Estimated Time: <span>1hr</span></h6>

                            <div className="mt-4">
                                <Button color="primary" type="submit" style={{ minWidth: "113px" }} onClick={checkDate}>
                                    {loading ? <ClipLoader color='white' size={16} /> : "Save Changes"}
                                </Button>
                            </div>
                        </Form>
                    )}
                </Formik>
            )}
            {loader && <div className='d-flex justify-content-center align-items-center' style={{ minHeight: "400px" }}>
                <FadeLoader color="#007bff" size={35} />
            </div>}
        </div>
    );
};

export default EditSiteSurvey;
